import type { ExplorationVolume } from '../../types/exploration';
import { buildDiskTypeOptions } from '../../lib/filters/buildCheckboxFilterOptions';
import FilterCheckboxList from './FilterCheckboxList';

export default function DiskTypeFilter({
  volumes,
  pendingDiskTypeFilters,
  setPendingDiskTypeFilters,
  isDisclosureOpen = false,
}: {
  volumes: ExplorationVolume[];
  pendingDiskTypeFilters: string[];
  setPendingDiskTypeFilters: (filters: string[]) => void;
  isDisclosureOpen?: boolean;
}) {
  const options = buildDiskTypeOptions(volumes);

  const handleChange = (diskType: string) => {
    if (pendingDiskTypeFilters.includes(diskType)) {
      setPendingDiskTypeFilters(pendingDiskTypeFilters.filter((d) => d !== diskType));
    } else {
      setPendingDiskTypeFilters([...pendingDiskTypeFilters, diskType]);
    }
  };

  if (!options.length) return null;

  return (
    <FilterCheckboxList
      options={options}
      isDisclosureOpen={isDisclosureOpen}
      isSelected={(key) => pendingDiskTypeFilters.includes(key)}
      onToggle={handleChange}
    />
  );
}

export function buildDiskTypeFilterOptions(volumes: ExplorationVolume[]) {
  return buildDiskTypeOptions(volumes);
}
